import UserFollowerIcon from 'assets/svgs/UserFollowerIcon';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import './CardProfileOrg.styles.scss';

interface DumpData {
  id: number;
  name: string;
  email_prefix: string;
  creator: number;
  description: string;
  image: string;
  joining_type: string;
  timestamp: string;
  colour: number;
  code: string;
  member_number: number;
}

interface CardProfileOrgProps {
  data: DumpData;
}

export const CardProfileOrg = ({ data }: CardProfileOrgProps) => {
  const navigate = useNavigate();

  const onDetail = () => {
    navigate(`/school/${data.id}`);
  };

  return (
    <div
      className="card_profile_org clickable"
      onClick={onDetail}
      style={{ width: '100%' }}
    >
      <div className="org_image">
        <img src={data.image} className="org_image" />
      </div>
      <div className="org_info">
        <div className="org_name font-bold font14">{data.name}</div>
        <div className="org_followers">
          <UserFollowerIcon size={16} color="rgba(0, 0, 0, 0.6)" />
          <div className="org_follower_txt font-regular font12">
            {data.member_number}
          </div>
        </div>
      </div>
    </div>
  );
};
